import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { appendDefaultStyle } from '../../../lib/style';
export class Textarea extends LitElement {
    constructor() {
        super(...arguments);
        this.wrap = 'soft';
        this.cssType = 'outlined';
    }
    render() {
        return html `
            <textarea
                class="outlined"
                @focusin="${this.focusin}"
                @focusout="${this.focusout}"
                @change="${this.change}"
                @keyup="${this.keyUp}"
                ?required="${this.required}"
                ?disabled="${this.disabled}"
                cols="${this.cols}"
                rows="${this.rows}"
                wrap="${this.wrap}"
                .value="${this.value}"
                placeholder="${this.placeholder}"
            >
            </textarea>
        `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.setIdToName();
        if (this.cols) {
            this._textarea.style.setProperty('--ep-textarea-width', 'auto');
        }
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('value')) {
            this.checkValue();
        }
        this.watchValid();
    }
    setIdToName() {
        this._textarea.setAttribute('id', this.name);
        this._textarea.setAttribute('name', this.name);
    }
    watchValid() {
        if (this.notValid !== undefined) {
            this._textarea.style.setProperty('border-color', 'var(--ep-color-danger)');
            return;
        }
        this._textarea.style.removeProperty('border-color');
    }
    checkValue() {
        if (this.value !== null && this.value !== undefined) {
            if (this.value.trim() !== '') {
                this.classList.remove('label-top');
                this.classList.add('label-top');
                return;
            }
        }
        if (this.placeholder !== null) {
            this.classList.remove('label-top');
            this.classList.add('label-top');
            return;
        }
        this.classList.remove('label-top');
    }
    focusin(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.classList.remove('label-top');
        this.classList.add('label-top');
        this.classList.add('focus');
    }
    focusout(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.checkValue();
        this.classList.remove('focus');
    }
    change(e) {
        e.stopPropagation();
        const value = String(e.currentTarget.value);
        this.dispatchEvent(new CustomEvent('change', {
            composed: true,
            detail: value
        }));
    }
    keyUp(e) {
        e.stopPropagation();
        const value = String(e.currentTarget.value);
        this.dispatchEvent(new CustomEvent('keyup', {
            composed: true,
            detail: value
        }));
    }
}
Textarea.styles = appendDefaultStyle(css `
        :host(:focus-visible),
        textarea:focus-visible {
            outline: 0;
        }

        textarea {
            line-height: 22px;
            width: var(--ep-textarea-width, 100%);
            padding: var(--ep-textarea-padding, 5px 5px 5px 13px);
            border: none;
            font-size: var(--ep-input-text-font-size, 14px);
            font-family: var(--ep-text-font-family);
            color: var(--ep-input-text-color, var(--ep-text-color));
            border-bottom: var(--ep-input-border-bottom, 2px solid var(--ep-input-border-bottom-color, var(--ep-color-tertiary)));
            resize: var(--ep-textarea-resize, none);
        }

        textarea.filled {
            background-color: var(--ep-input-filled-background-color, lightgray);
            border-radius: var(--ep-input-filled-border-radius, 3px 3px 0 0);
        }

        textarea.outlined {
            border: var(--ep-textarea-border, 2px solid var(--ep-color-tertiary));
            border-radius: var(--ep-textarea-border-radius, 3px);
        }

        textarea::placeholder {
            font-size: var(--ep-textarea-placeholder-font-size, var(--ep-text-font-size));
            color: var(--ep-textarea-placeholder-color, var(--ep-text-color));
        }

        textarea:focus {
            border-color: var(--ep-textarea-focus-border-color, var(--ep-color-primary));
        }

        ::slotted(*) {
            display: none;
        }

        :host([not-valid]) textarea {
            border-color: var(--ep-color-danger);
        }

        textarea:disabled {
            background-color: var(--ep-color-gray-3);
            cursor: not-allowed;
        }
    `);
__decorate([
    property()
], Textarea.prototype, "name", void 0);
__decorate([
    property()
], Textarea.prototype, "value", void 0);
__decorate([
    property()
], Textarea.prototype, "placeholder", void 0);
__decorate([
    property()
], Textarea.prototype, "rows", void 0);
__decorate([
    property()
], Textarea.prototype, "cols", void 0);
__decorate([
    property()
], Textarea.prototype, "wrap", void 0);
__decorate([
    property({ type: Boolean })
], Textarea.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], Textarea.prototype, "required", void 0);
__decorate([
    property({ type: Boolean })
], Textarea.prototype, "notValid", void 0);
__decorate([
    property()
], Textarea.prototype, "cssType", void 0);
__decorate([
    query('textarea')
], Textarea.prototype, "_textarea", void 0);
if (!customElements.get('ep-textarea')) {
    customElements.define('ep-textarea', Textarea);
}
//# sourceMappingURL=element.js.map